import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMiniLateral } from '../../actions/ui';
import { 
    ClientesIcon, 
    ConfigIcon, 
    SuscripcionIcon,
    SuscripcionIconSuperAdmin,
    PreciosEspecialesIcon, 
    ProfesionalesIcon, 
    PuntoVentaIcon, 
    ReservasIcon, 
    SelectArrowIcon, 
    SucursalesIcon, 
    SuperAdminIcon, 
    EmpresasIcon, 
    IdiomasIcon, 
    SectorIcon, 
    PlanesIcon,
    FacturacionIcon,
    CreditCardIcon,
    SmsLogsIcon
} from '../../assets/svg/iconos';
import { NOMBRE_PANTALLA_REVISION, puedeRevisarCobros } from '../../helpers/cobroDatafono';

export const MenuLateral = ({ history, setMenuActive, mobileMenuOpen, setMobileMenuOpen }) => {
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const { suscripcion } = useSelector(state => state.suscripciones);
    const suscripcionAuth = auth?.actualSuscripcion;
    const suscripcionActual = suscripcion?._id ? suscripcion : suscripcionAuth;
    
    const estadoSuscripcion = suscripcionActual?.estado;
    const autoRenovar = suscripcionActual?.autoRenovar !== undefined 
      ? suscripcionActual.autoRenovar 
      : true;
    
    const suscripcionActiva = estadoSuscripcion !== 'cancelada' && autoRenovar !== false;
    const esProfesional = !!auth.profesional;
    const { miniLateral, colores } = useSelector(state => state.ui);
    const { profesionales } = useSelector(state => state.profesionales);
    const { pendientes: cobrosPorRevisar } = useSelector(state => state.cobrosRevision);

    //const [permisos, setPermisos] = useState([]);
    const [hovering, setHovering] = useState('');
    const [menuActive, setMenuActiveLocal] = useState('reservas');

    //console.log('Auth.empresa:', auth.empresa);
    //console.log('Auth.actualSuscripcion:', auth?.actualSuscripcion);

    useEffect(() => {
      if( auth?.role === 'BUSINESS_ROLE' || auth?.role === 'PROFESSIONAL_ROLE' ){
          //console.log( auth );
        //const profesional = profesionales.filter( prof => prof._id === auth.profesional );
        //console.log( profesional );
      }
    }, [auth, profesionales]);

    // Detectar la ruta actual y actualizar el menú activo
    useEffect(() => {
        const path = window.location.pathname;
        let activeMenu = '';
        
        if (path.startsWith('/profesional/')) {
            activeMenu = 'profesionales';
        } else if (path.startsWith('/cliente/')) {
            activeMenu = 'clientes';
        } else {
            switch (path) {
                case '/reservas':
                    activeMenu = 'reservas';
                    break;
                case '/profesionales':
                    activeMenu = 'profesionales';
                    break;
                case '/clientes':
                    activeMenu = 'clientes';
                    break;
                case '/punto-venta':
                    activeMenu = 'punto-venta';
                    break;
                case '/precios-especiales':
                    activeMenu = 'precios-especiales';
                    break;
                case '/notificaciones':
                    activeMenu = 'notificaciones';
                    break;
                case '/sucursales':
                    activeMenu = 'sucursales';
                    break;
                case '/configuracion':
                    activeMenu = 'configuracion';
                    break;
                case '/suscripciones':
                    activeMenu = 'suscripciones';
                    break;
                case '/admin':
                    activeMenu = 'admin';
                    break;
                case '/empresas':
                    activeMenu = 'empresas';
                    break;
                case '/idiomas':
                    activeMenu = 'idiomas';
                    break;
                case '/sectores':
                    activeMenu = 'sectores';
                    break;
                case '/planes':
                    activeMenu = 'planes';
                    break;
                case '/ventas':
                    activeMenu = 'ventas';
                    break;
                case '/cobros-revision':
                    activeMenu = 'cobros-revision';
                    break;
                case '/sms-logs':
                    activeMenu = 'sms-logs';
                    break;
                default:
                    activeMenu = 'reservas';
            }
        }
        
        // Actualizar el estado del menú lateral
        setMenuActiveLocal(activeMenu);
        if (setMenuActive) {
            setMenuActive(activeMenu);
        }
    }, [setMenuActive, history.location]);

    const menuItemClick = ( item ) => {
        if (setMobileMenuOpen) {
            setMobileMenuOpen(false);
        }
        
        switch (item) {
            case 'reservas':
                history.push('/reservas');
                break;

            case 'profesionales':
                history.push('/profesionales');
                break;

            case 'clientes':
                history.push('/clientes');
                break;
            
            case 'punto-venta':
                history.push('/punto-venta');
                break;
            
            case 'precios-especiales':
                history.push('/precios-especiales');
                break;
            
            case 'notificaciones':
                history.push('/notificaciones');
                break;

            case 'sucursales':
                history.push('/sucursales');
                break;

            case 'configuracion':
                history.push('/configuracion');
                break;

            case 'suscripciones':
                history.push('/suscripciones');
                break;    

            case 'admin':
                history.push('/admin');
                break;
            
            case 'empresas':
                history.push('/empresas');
                break;
            
            case 'idiomas':
                history.push('/idiomas');
                break;
            
            case 'sectores':
                history.push('/sectores');
                break;
            
            case 'planes':
                history.push('/planes');
                break;

            case 'ventas':
                history.push('/ventas');
                break;

            case 'cobros-revision':
                history.push('/cobros-revision');
                break;

            case 'sms-logs':
                history.push('/sms-logs');
                break;
        
            default:
                break;
        }
    }    

    const minimize = () => {
        //setMiniLateral(!miniLateral);
        dispatch( setMiniLateral( !miniLateral ) );
    }
	    
    return (
        <div 
            className={`menu-lateral  ${(miniLateral ? 'mini' : '')} ${(mobileMenuOpen ? 'open' : '')}`}
            style={{
                '--colorPrincipal': colores.colorPrincipal,
                '--colorSecundario': colores.colorSecundario,
                '--color3': colores.color3,
                '--color4': colores.color4,
                '--color5': colores.color5,
                '--color6': colores.color6,
                '--color7': colores.color7,
            }}
        >

            {!esProfesional && (
                <>     
                    {
                        ((auth.role !== 'SUPERADMIN_ROLE' && auth.role !== 'ADMIN_ROLE') || window.location.hostname != process.env.REACT_APP_ADMIN_URL) &&
                        (
                            <>
                                <div
                                    className={`btn-minimize`}
                                    style={{ backgroundColor: colores.colorSecundario }}
                                    onClick={minimize}
                                >
                                    <SelectArrowIcon />
                                </div>

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-reservas ${menuActive === 'reservas' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('reservas')}
                                        style={{ backgroundColor: menuActive === 'reservas' ? colores.color3 : hovering === 'reservas' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('reservas')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <ReservasIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Reservas</p>
                                    </div>
                                )}

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-profesionales ${menuActive === 'profesionales' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('profesionales')}
                                        style={{ backgroundColor: menuActive === 'profesionales' ? colores.color3 : hovering === 'profesionales' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('profesionales')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <ProfesionalesIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Profesionales</p>
                                    </div>
                                )}

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-clientes ${menuActive === 'clientes' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('clientes')}
                                        style={{ backgroundColor: menuActive === 'clientes' ? colores.color3 : hovering === 'clientes' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('clientes')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <ClientesIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Clientes</p>
                                    </div>
                                )}

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-punto-venta ${menuActive === 'punto-venta' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('punto-venta')}
                                        style={{ backgroundColor: menuActive === 'punto-venta' ? colores.color3 : hovering === 'punto-venta' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('punto-venta')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <PuntoVentaIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Punto de venta</p>
                                    </div>
                                )}

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-servicios ${menuActive === 'precios-especiales' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('precios-especiales')}
                                        style={{ backgroundColor: menuActive === 'precios-especiales' ? colores.color3 : hovering === 'precios-especiales' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('precios-especiales')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <PreciosEspecialesIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Precios especiales</p>
                                    </div>
                                    /* <div 
                                        className={ `menu-item menu-notificaciones ${(menuActive === 'notificaciones' ? 'active' : '')}` }
                                        onClick={ () => menuItemClick('notificaciones') }
                                        style={{ backgroundColor: menuActive ===  'notificaciones' ? colores.color3 : hovering === 'notificaciones' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={ () => setHovering('notificaciones') }
                                        onMouseLeave={ () => setHovering('') }
                                    >
                                    <div className="menu-icon">
                                        <NotificacionesIcon color={ colores.colorPrincipal } />
                                    </div>
                                        <p style={{ color: colores.colorPrincipal }}>Notificaciones</p>
                                    </div> */
                                )}

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-sucursales ${menuActive === 'sucursales' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('sucursales')}
                                        style={{ backgroundColor: menuActive === 'sucursales' ? colores.color3 : hovering === 'sucursales' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('sucursales')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <SucursalesIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Locales</p>
                                    </div>
                                )}

                                {suscripcionActiva && (
                                    <div 
                                        className={`menu-item menu-ventas ${menuActive === 'ventas' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('ventas')}
                                        style={{ backgroundColor: menuActive === 'ventas' ? colores.color3 : hovering === 'ventas' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('ventas')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <FacturacionIcon color={colores.colorSecundario} />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Facturación</p>
                                    </div>
                                )}

                                {/* EX-607: el contador es la unica senal de que hay dinero cobrado
                                    fuera de facturacion, asi que el item solo aparece cuando el rol
                                    puede hacer algo al respecto. */}
                                {suscripcionActiva && puedeRevisarCobros(auth.role) && (
                                    <div
                                        className={`menu-item menu-cobros-revision ${menuActive === 'cobros-revision' ? 'active' : ''}`}
                                        onClick={() => menuItemClick('cobros-revision')}
                                        style={{ backgroundColor: menuActive === 'cobros-revision' ? colores.color3 : hovering === 'cobros-revision' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={() => setHovering('cobros-revision')}
                                        onMouseLeave={() => setHovering('')}
                                    >
                                        <div className="menu-icon">
                                            <CreditCardIcon color={colores.colorSecundario} />
                                            {cobrosPorRevisar > 0 && (
                                                <span className="menu-badge">{cobrosPorRevisar}</span>
                                            )}
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>
                                            {NOMBRE_PANTALLA_REVISION}
                                        </p>
                                    </div>
                                )}

                                <div 
                                    className={`menu-item menu-suscripciones ${menuActive === 'suscripciones' ? 'active' : ''}`}
                                    onClick={() => menuItemClick('suscripciones')}
                                    style={{ backgroundColor: menuActive === 'suscripciones' ? colores.color3 : hovering === 'suscripciones' ? colores.color3 : 'transparent' }}
                                    onMouseEnter={() => setHovering('suscripciones')}
                                    onMouseLeave={() => setHovering('')}
                                >
                                    <div className="menu-icon">
                                        <SuscripcionIcon color={colores.colorSecundario} />
                                    </div>
                                    <p style={{ color: colores.colorPrincipal }}>Suscripción</p>
                                </div>
                                
                                {suscripcionActiva && (
                                    <div 
                                        className={ `menu-item menu-configuracion ${(menuActive === 'configuracion' ? 'active' : '')}` }
                                        onClick={ () => menuItemClick('configuracion') }
                                        style={{ backgroundColor: menuActive ===  'configuracion' ? colores.color3 : hovering === 'configuracion' ? colores.color3 : 'transparent' }}
                                        onMouseEnter={ () => setHovering('configuracion') }
                                        onMouseLeave={ () => setHovering('') }
                                    >
                                        <div className="menu-icon">
                                            <ConfigIcon color={ colores.colorSecundario } />
                                        </div>
                                        <p style={{ color: colores.colorPrincipal }}>Configuracion</p>
                                    </div>
                                )}
                                
                                <div 
                                    className={ `menu-item menu-super-admin ${(menuActive === 'admin' ? 'active' : '')}` }
                                    onClick={ () => menuItemClick('admin') }
                                    style={{ backgroundColor: menuActive ===  'admin' ? colores.color3 : hovering === 'admin' ? colores.color3 : 'transparent' }}
                                    onMouseEnter={ () => setHovering('admin') }
                                    onMouseLeave={ () => setHovering('') }
                                >
                                    <div className="menu-icon">
                                        <SuperAdminIcon color={ colores.colorSecundario } />
                                    </div>
                                    <p style={{ color: colores.colorPrincipal }}>Admin</p>
                                </div>
                            </>
                        )
                    }
                    {
                        (auth.role === 'SUPERADMIN_ROLE' || auth.role === 'ADMIN_ROLE') && (window.location.hostname === process.env.REACT_APP_ADMIN_URL) && (
                            <>
                                <div className={`btn-minimize`} onClick={minimize}>
                                    <SelectArrowIcon />
                                </div>

                                <div 
                                    className={`menu-item menu-empresas ${menuActive === 'empresas' ? 'active' : ''}`}
                                    onClick={() => menuItemClick('empresas')}
                                >
                                    <div className="menu-icon">
                                        <EmpresasIcon />
                                    </div>
                                    <p>Empresas</p>
                                </div>

                                <div 
                                    className={`menu-item menu-sector ${menuActive === 'sectores' ? 'active' : ''}`}
                                    onClick={() => menuItemClick('sectores')}
                                >
                                    <div className="menu-icon">
                                        <SectorIcon />
                                    </div>
                                    <p>Sectores</p>
                                </div>

                                <div 
                                    className={`menu-item menu-planes ${menuActive === 'planes' ? 'active' : ''}`}
                                    onClick={() => menuItemClick('planes')}
                                >
                                    <div className="menu-icon">
                                        <PlanesIcon />
                                    </div>
                                    <p>Planes</p>
                                </div>

                                <div 
                                    className={`menu-item menu-suscripciones ${menuActive === 'suscripciones' ? 'active' : ''}`}
                                    onClick={() => menuItemClick('suscripciones')}
                                >
                                    <div className="menu-icon">
                                        <SuscripcionIconSuperAdmin />
                                    </div>
                                    <p>Suscripciones</p>
                                </div>

                                <div 
                                    className={`menu-item menu-sms-logs ${menuActive === 'sms-logs' ? 'active' : ''}`}
                                    onClick={() => menuItemClick('sms-logs')}
                                >
                                    <div className="menu-icon">
                                        <SmsLogsIcon />
                                    </div>
                                    <p>SMS Logs</p>
                                </div>
                            </>
                        )
                    }
                </>
            )}

            {esProfesional && (
                <>
                    <div 
                        className={`menu-item menu-reservas ${(menuActive === 'reservas' ? 'active' : '')}`}
                        onClick={() => menuItemClick('reservas')}
                        style={{
                            backgroundColor: menuActive === 'reservas' ? colores.color3 :
                            hovering === 'reservas' ? colores.color3 : 'transparent'
                        }}
                        onMouseEnter={() => setHovering('reservas')}
                        onMouseLeave={() => setHovering('')}
                    >
                        <div className="menu-icon">
                            <ReservasIcon color={colores.colorSecundario} />
                        </div>
                        <p style={{ color: colores.colorPrincipal }}>Mi Agenda</p>
                    </div>
                    
                    {/* <div 
                        className={`menu-item menu-profesionales ${(menuActive === 'profesionales' ? 'active' : '')}`}
                        onClick={() => history.push(`/profesional/${auth.profesional}`)}
                        style={{
                            backgroundColor: menuActive === 'profesionales' ? colores.color3 :
                            hovering === 'profesionales' ? colores.color3 : 'transparent'
                        }}
                        onMouseEnter={() => setHovering('profesionales')}
                        onMouseLeave={() => setHovering('')}
                    >
                        <div className="menu-icon">
                            <ProfesionalesIcon color={colores.colorSecundario} />
                        </div>
                        <p style={{ color: colores.colorPrincipal }}>Mi Perfil</p>
                    </div> */}
                </>
            )}
        </div>
    )
}
